import { render, staticRenderFns } from "./TermsOfProject.vue?vue&type=template&id=025e56b4&"
import script from "./TermsOfProject.vue?vue&type=script&lang=js&"
export * from "./TermsOfProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports